// @ts-nocheck: converted from JS

const CancelStudy = ({ closeModal, onClick }) => {
  const handleSubmit = (e) => {
    e.preventDefault();
    onClick();
  };

  return (
    <form onSubmit={handleSubmit} className="ui__narrow-modal">
      <div className="pb3 tc">
        <h3 className="normal f4 pb2">Are you sure you would like to cancel this study?</h3>
        <p className="f6 pb2">
          <div>
            <p className="mt2 mb3">If a study is cancelled it will become read-only and has limited functionality.</p>
            <p>Cancelled studies can be resumed later in it&apos;s settings page.</p>
          </div>
        </p>
      </div>
      <div>
        <button type="submit" className="button w-100">
          Cancel study
        </button>
        <a className="button plain db w-100 mt2" onClick={closeModal}>
          Dismiss
        </a>
      </div>
    </form>
  );
};

export default CancelStudy;
